import { c as _c } from "react/compiler-runtime";
const CourseModulesSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex animate-pulse gap-7"><div className="bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent">.</div><div className="bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent">.</div><div className="bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent">.</div><div className="bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent">.</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default CourseModulesSkeleton;